import { useRef, useEffect, useState } from 'react';
import { stats } from '../../../mocks/home';

const StatsSection = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 bg-navy relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-px h-full bg-teal/10"></div>
        <div className="absolute top-0 left-2/4 w-px h-full bg-teal/10"></div>
        <div className="absolute top-0 left-3/4 w-px h-full bg-teal/10"></div>
        <div className="absolute top-0 left-0 right-0 h-px bg-teal/10"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-teal/10"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className={`text-center mb-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-teal font-body text-xs tracking-widest uppercase mb-3">Our Track Record</p>
          <h2 className="font-heading font-800 text-white text-4xl lg:text-5xl">
            Numbers That Speak for Themselves
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, i) => (
            <div
              key={i}
              className={`text-center py-10 px-6 rounded-2xl bg-white/5 border border-white/10 hover:border-teal/30 hover:bg-teal/5 transition-all duration-300 group ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: visible ? `${i * 100}ms` : '0ms' }}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal/15 group-hover:bg-teal/25 rounded-xl mx-auto mb-5 transition-colors duration-300">
                <i className={`${stat.icon} text-teal text-2xl`}></i>
              </div>
              <div className="font-heading font-800 text-white leading-none mb-2" style={{ fontSize: '3rem' }}>
                {stat.value}
              </div>
              <div className="text-text-muted font-body text-sm tracking-wide">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Trust row */}
        <div className={`mt-12 flex flex-wrap items-center justify-center gap-6 transition-all duration-700 delay-500 ${visible ? 'opacity-100' : 'opacity-0'}`}>
          {[
            'Licensed & Insured in Minnesota',
            'A+ BBB Rated',
            'No Hidden Fees',
            'Same-Day Response',
          ].map((item) => (
            <div key={item} className="flex items-center gap-2">
              <i className="ri-check-line text-teal text-sm"></i>
              <span className="text-white/50 font-body text-sm">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
